import React from 'react';

// SVG Inline
import SVG from 'react-inlinesvg';

import DesconectedSrc from 'assets/images/icons/DesignSysten2.0/tech_web_device/Sem Conexão.svg';
import WebSrc from 'assets/images/icons/DesignSysten2.0/tech_web_device/WEB.svg';
import WifiStrongSignalSrc from 'assets/images/icons/DesignSysten2.0/tech_web_device/wi-fi Strong Signal.svg';
import GoogleSrc from 'assets/images/icons/DesignSysten2.0/tech_web_device/logo googleg 48dp.svg';
import AppleSrc from 'assets/images/icons/DesignSysten2.0/tech_web_device/logo apple 48dp.svg';
import PrintSrc from 'assets/images/icons/DesignSysten2.0/tech_web_device/Print.svg';

interface SVGInlineInterface {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const Desconected: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={DesconectedSrc}
    style={{ width, height }}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const WifiStrongSignal: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={WifiStrongSignalSrc}
    style={{ width, height }}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Web: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={WebSrc}
    style={{ width, height }}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Google: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={GoogleSrc}
    style={{ width, height }}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Print: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={PrintSrc}
    style={{ width, height }}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Apple: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={AppleSrc}
    style={{ width, height }}
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
